import React from 'react'

import * as S from './styled'

const Loading = () => <S.Wrapper />

export default React.memo(Loading)
